import i18n from '../i18n';

export type PluralForm = 'one' | 'few' | 'many';

/**
 * Форма существительного после числа для польского и русского (ТЗ 0074).
 *
 * Явная функция вместо суффиксов i18next (`_one/_few/_many`): в LMS их нет ни
 * одного, а правила двух языков расходятся ровно там, где ошибка заметнее
 * всего, — на 21, 22 и 12:
 *   pl: 1 faktura · 2–4, 22–24 faktury · 0, 5–21, 25… faktur (12–14 → faktur)
 *   ru: 1, 21 фактура · 2–4, 22–24 фактуры · 0, 5–20, 11–14 фактур
 */
export const pluralForm = (count: number, language: string = i18n.language): PluralForm => {
  const n = Math.abs(Math.trunc(count));
  const lastDigit = n % 10;
  const lastTwo = n % 100;
  const isTeen = lastTwo >= 12 && lastTwo <= 14;

  if (language.startsWith('pl')) {
    if (n === 1) return 'one';
    if (lastDigit >= 2 && lastDigit <= 4 && !isTeen) return 'few';
    return 'many';
  }

  if (lastDigit === 1 && lastTwo !== 11) return 'one';
  if (lastDigit >= 2 && lastDigit <= 4 && !isTeen) return 'few';
  return 'many';
};
